import { Button, SelectWithLabel } from 'components/Form'
import ModalWrapper from 'components/ModalWrapper'
import React, { useEffect, useState } from 'react'
import { I18n } from 'react-redux-i18n'
import { getStaticImage } from 'utils/statics'
import { company as companyApi } from 'api'
import './styles.scss'
const _ = require('lodash')
const { channels: channelsApi } = companyApi

const DelegateModal = (props) => {
  const { mailProvider, isOpen, toggle, onChange: onChangeExternal, schema, onSubmit, channel } = props
  const [ state, setState ] = useState({ email: '', timeFrame: '' })
  const [ stateError, setStateError ] = useState({ email: '', timeFrame: '' })
  const [ isSubmitting, setIsSubmitting ] = useState(false)
  const errorRequiredField = I18n.t('dashboard_errors_required-field')
  const optionsTimeFrame = schema?.schema?.timeFrame?.options.map(it => ({ value: it.value, label: I18n.t(it.label) })) || []

  useEffect(() => {
    if (channel.value) {
      let _state = _.clone(state)
      if (channel?.value?.timeFrame) _.set(_state, 'timeFrame', channel.value.timeFrame)
      setState(_state)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channel.value])

  useEffect(() => {
    let _stateError = _.clone(stateError)
    if (state?.timeFrame) _stateError = { ..._stateError, timeFrame: '' }
    setStateError(_stateError)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state])

  const onSave = async () => {
    let error = false
    let _stateError = _.clone(stateError)
    if (!state.timeFrame) {
      _stateError = { ..._stateError, timeFrame: errorRequiredField }
      error = true
    }
    if (error) {
      setStateError(_stateError)
      return
    }

    try {
      setIsSubmitting(true)
      let id = channel?._id
      if (channel?.isNew || !channel?.value?.email) {
        const result = await onSubmit()
        id = result._id
      }
      setIsSubmitting(false)
      if (id) {
        const { data } = await channelsApi.getUri({ type: mailProvider.key, channelId: id })
        window.open(data.oauthURI, '_self')
      }
    } catch (error) {
      setIsSubmitting(false)
      console.error(error)
    }
  }

  const onChange = (field, value) => {
    const _state = _.clone(state)
    _.set(_state, field, value)
    setState(_state)
    onChangeExternal(_state)
  }

  return (
    <ModalWrapper
      id={'modalAccountDelegate'}
      header=' '
      body={
        mailProvider
          ?
          <div className='delegate-wrapper'>
            <img className={`delegate-image`} alt={mailProvider.key} src={getStaticImage(`/icons/orange-brand/icon-${mailProvider.key}.png`)}/>
            <h2>{`${I18n.t('dashboard_add-account-of')} ${mailProvider.label}`}</h2>
            {
              mailProvider.key === 'gmail'
                ?
                <button className='button-google-2' onClick={onSave}>
                  <img alt='google' src={getStaticImage('/btn_google_light_normal.svg')}/>
                  <label>{I18n.t('buttons_google_login')}</label>
                </button>
                // <div className='button-google' onClick={onSave}>
                //   <img src={getStaticImage('/btn_google_signin_light_normal_web.png')} alt='buton'/>
                // </div>
                :
                <Button className={`delegate-button ${mailProvider.key}`} value={`${I18n.t('dashboard_signin-with')} ${mailProvider.label}`} onClick={onSave} isSubmitting={isSubmitting}/>
            }
            <div className='delegate-select-wrapper'>
              <label className='label-select'>{'Importar'}</label>
              <SelectWithLabel
                placeholder={`${I18n.t('dashboard_select')}`}
                options={optionsTimeFrame}
                onChange={(value) => onChange('timeFrame', value.value)}
                value={optionsTimeFrame.find(it => it.value === state.timeFrame) || ''}
              />
              {stateError?.timeFrame && <span className='error-message'>{stateError?.timeFrame}</span>}
            </div>

          </div>
          :
          null
      }
      isOpen={isOpen}
      toggle={toggle}
      showClose={true}
    />
  )
}

export default DelegateModal
